import { userStore } from '@/stores/user';



const wsUrl = import.meta.env.VITE_APP_API_WEBSOCKET
class ws {
  constructor({ onMessageCD }) {
    this.socketTask = null
    this.reconnectTimeOut = null
    this.heartbeatInterval = null
    this.connectUserId = null
    this.onMessageCD = onMessageCD
    this.connectSocket()
  }

  connectSocket() {
    if (this.socketTask) {
      this.socketTask.close()
      this.socketTask = null
    }
    if (this.reconnectTimeOut) {
      clearInterval(this.reconnectTimeOut)
      this.reconnectTimeOut = null
    }

    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval)
      this.heartbeatInterval = null
    }
    this.socketTask = new WebSocket(wsUrl)
    if (!this.socketTask) {
      return
    }
    this.onOpen()
    this.onClose()
    this.onError()
    if (this.onMessageCD) {
      this.onMessage(this.onMessageCD)
    }

  }

  onOpen() {
    this.socketTask.onopen = () => {
      clearInterval(this.reconnectTimeOut)
      clearInterval(this.heartbeatInterval)
      const bindingObj = {
        type: 'bind',
        data: {
          logId: window.sessionStorage.getItem('logId'),
          token: userStore().token
        }
      }
      this.socketTask.send(JSON.stringify(bindingObj))
      this.heartbeatInterval = setInterval(() => {
        const boomingObj = {
          type: 'boom',
          data: {
            logId: window.sessionStorage.getItem('logId'),
            ping: 'ping',
          }
        }
        this.socketTask.send(JSON.stringify(boomingObj))
      }, 10000)

    }
  }

  send(msg) {
    if (this.socketTask) {
      this.socketTask.send(JSON.stringify(msg))
    }
  }

  onClose() {
    this.socketTask.onclose = (e) => {
      clearInterval(this.heartbeatInterval)
      clearInterval(this.reconnectTimeOut)
      console.log('WebSocket closed:', e);
      if (e.code !== 1000) {
        this.reconnectTimeOut = setInterval(() => {
          this.connectSocket()
        }, 5000)
      }

    }
  }


  close(code = 1000) {
    if (this.socketTask) {
      this.socketTask.close(code)
    }
  }

  onError() {
    this.socketTask.onerror = () => {
      console.log('WebSocket error, attempting to reconnect...');
      clearInterval(this.reconnectTimeOut)
      clearInterval(this.heartbeatInterval)

      this.reconnectTimeOut = setInterval(() => {
        this.connectSocket()
      }, 5000)
    }
  }

  onMessage(CALLBACK) {
    this.socketTask.onmessage = (msg) => {
      console.log(JSON.parse(msg.data))
      if (JSON.parse(msg.data).type === 'error') {
        this.close()

        this.reconnectTimeOut = setInterval(() => {
          this.connectSocket()
        }, 5000)
        return
      }



      console.log('Received message:', msg);

      CALLBACK && CALLBACK(msg)
    }
  }
}

export default ws
